"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Stagger, StaggerItem } from "@/components/shared/motion";
import { Zap, ShieldCheck, Globe2, Headset } from "lucide-react";

/**
 * AquaGlobe trust strip — a slim frosted-glass strip of reassurance items with
 * glowing glass icon tiles. Claim-safe copy only. Glass-native.
 */
export default function TrustStrip() {
  const { t } = useTranslations();

  const items = [
    { Icon: Zap, label: t("aqua.trust.instant", "Instant delivery") },
    { Icon: ShieldCheck, label: t("aqua.trust.secure", "Secure payment") },
    { Icon: Globe2, label: t("aqua.trust.global", "Global coverage") },
    { Icon: Headset, label: t("aqua.trust.support", "24/7 traveler support") },
  ];

  return (
    <section className="container mx-auto px-4 -mt-4">
      <Stagger
        className="aqua-glass rounded-3xl p-5 backdrop-blur grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-4"
        staggerChildren={0.07}
        amount={0.4}
      >
        {items.map(({ Icon, label }, i) => (
          <StaggerItem key={i} y={10} className="inline-flex items-center gap-3 text-sm font-medium text-foreground/85">
            <span className="aqua-icon inline-flex items-center justify-center rounded-2xl p-3 backdrop-blur shrink-0">
              <Icon className="h-5 w-5 text-primary" />
            </span>
            {label}
          </StaggerItem>
        ))}
      </Stagger>
    </section>
  );
}
